export const mediaPosts = [
  {
    id: 1,
    titleKey: "media.posts.1.title",
    excerptKey: "media.posts.1.excerpt",
    contentKey: "media.posts.1.content", 
    image:
      "https://res.cloudinary.com/dxgqcmf7j/image/upload/v1766394179/bt8ryuq98lftzr9zudpd.jpg",
    date: "2025-03-14",
  },
];